module.exports = __webpack_public_path__ + "static/media/imageLoader.1cbc65b1.gif";